import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const g = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-xianhuowangge", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ç°è´§ç½æ ¼"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16.997 13.143c.314.526.811.93 1.404 1.126l-3.651 4.493a2.578 2.578 0 0 0-1.454-1.065l3.7-4.554Zm-8.703 1.789 2.274 3.662c.373-.48.913-.823 1.532-.944l-2.277-3.668a.9.9 0 0 0-1.53.95Zm11.479-.596a2.576 2.576 0 0 0 1.507-.985l2.438 3.789a.9.9 0 0 1-1.514.974l-2.43-3.778Zm-1.983-2.511a1.416 1.416 0 1 0 2.831 0 1.416 1.416 0 0 0-2.83 0Zm-5.19 9.766a1.416 1.416 0 1 1 0-2.831 1.416 1.416 0 0 1 0 2.831Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M9 4.1A4.9 4.9 0 0 0 4.1 9v14A4.9 4.9 0 0 0 9 27.9h14a4.9 4.9 0 0 0 4.9-4.9V9A4.9 4.9 0 0 0 23 4.1H9ZM5.9 9A3.1 3.1 0 0 1 9 5.9h14A3.1 3.1 0 0 1 26.1 9v14a3.1 3.1 0 0 1-3.1 3.1H9A3.1 3.1 0 0 1 5.9 23V9Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, A = f;
export {
  A as default
};
